import gql from 'graphql-tag';

export default gql`
mutation deleteSnippetV2($snippetId: Int!) {
  delete_snippets_v2_by_pk(snippet_id: $snippetId) {
    snippet_id
  }
}
`;
